import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Feed from './components/feed';
import Patients from './components/patients';
import { HomeSC } from './home.styled';
// import { TPatient } from '../../types/patients';
import { useAppSelector } from '@hooks/app/redux';
import { SHOWED_INT_MODAL } from '../../constants/local-storage';
import { initializeWidget, RemoveWidget } from '../../helpers/support-widget';
import { actions as appActions } from '../../store/ducks/app';
import { useMediaQuery } from 'react-responsive';

const Home: React.FC = () => {
  // const [isScrolled, setIsScrolled] = React.useState(false);
  // const [isSecured, setIsSecured] = React.useState(true);

  const dispatch = useDispatch();
  // const patients: TPatient[] = useSelector((store: TStore) => store.patients.patients);
  const currentUser = useAppSelector((store) => store.users.currentUser);
  // const MAX_PATIENTS = 100;
  // const fill = (patients.length / MAX_PATIENTS) * 100;

  useEffect(() => {
    const modalBeenShowed = localStorage.getItem(SHOWED_INT_MODAL);
    if (currentUser?.registerCode && !modalBeenShowed) {
      dispatch(appActions.openModal({ id: 'CONNECT_SOFTWARE' }));
    }
  }, [currentUser, dispatch]);

  useEffect(() => {
    initializeWidget();
    return () => {
      RemoveWidget();
    };
  }, []);

  const isSmall = useMediaQuery({ query: '(max-width: 992px)' });

  return (
    <HomeSC>
      {/* <section className="stats-section">
        <StatsWidget
          label="stats.my_wallet"
          labelTooltip="Info"
          units="EUR"
          fill={0}
          isScrolled={isScrolled}
          isSecured={isSecured}
          hasEyeButton={true}
          setIsMouseDown={() => setIsSecured(false)}
          setIsMouseUp={() => setIsSecured(true)}
          setIsMouseLeave={() => setIsSecured(true)}
          className="first"
        >
          {isSecured ? (
            <p>
              <FormattedMessage id="stats.my_wallet_hidden" />
            </p>
          ) : (
            <>
              <p>
                <FormattedMessage id="stats.my_wallet_stats" />
              </p>
            </>
          )}
        </StatsWidget>
        {isScrolled ? (
          <StatsWidget
            label="stats.my_patients"
            units={
              patients.length > 1 && patients.length < 5 ? (
                <FormattedMessage id="stats.patients" />
              ) : patients.length > 4 ? (
                <FormattedMessage id="stats.patients_more" />
              ) : (
                <FormattedMessage id="stats.patients_one" />
              )
            }
            fill={fill}
            value={patients.length}
            isScrolled={isScrolled}
            hasEyeButton={false}
            setIsMouseDown={null}
            setIsMouseUp={null}
            setIsMouseLeave={null}
          />
        ) : (
          <StatsWidgetPatients />
        )}
        <StatsWidget
          label="stats.my_profil"
          units={<FormattedMessage id="stats.rank" />}
          fill={0}
          isScrolled={isScrolled}
          hasEyeButton={false}
          setIsMouseDown={null}
          setIsMouseUp={null}
          setIsMouseLeave={null}
        >
          <p>
            <FormattedMessage id="stats.not_available" />
          </p>
        </StatsWidget>
      </section> */}
      <div className="home-content">
        <main className="feed-section">
          <Feed />
        </main>
        {isSmall ? null : (
          <aside className="patients-section">
            <Patients />
          </aside>
        )}
      </div>
    </HomeSC>
  );
};

export default Home;
